<div class="card">
  <div class="card-body">
    <div class="tab-content">
      <div role="tabpanel" class="tab-pane fade active show" id="dpending">
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div class="float-left my-1">
              <label>{{'header.assesmentyear' | translate }}<span class="required-field">*</span></label>
              <select [(ngModel)]="dgcFilter['ay']" class="form-control custom-selectbox">
                <option *ngFor="let year of yearDropDownList" value="{{year}}">{{year}}</option>
              </select>
            </div>
            <div class="float-left form-control-lg" style="margin-top:39px;" *ngIf="dgcFilter['ay'] ">
              <button class="btn btn-info btn-sm mt-1" (click)="getReportData()" name="submit" type="button"
                [disabled]="disableedit">{{'dataSubs.VIEW' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="table-responsive table-responsive-lg table-responsive-md table-responsive-sm"> -->
      <!-- <cdk-virtual-scroll-viewport #scrollViewport itemSize="50"
      [style.height]="fetchReport && fetchReport.length > 0 ? '500px' : '185px'"> -->
      
      <div id="single-column-chart" class="mt-3 pointer"></div>
      <hr class="bg-dark">      
      
      <div class="row text-center">
      <div class="table-responsive m-2" id="content">
        <table class="table table-sm w-50" *ngIf="tableData && tableData.length > 0">
        <thead class="thead-light" >
          <tr style="position:sticky; top: -0.5px;">
            <th style="background-color:black; color: white;">{{ 'dataSubs.month' | translate }}</th>
            <th style="background-color:black; color: white;">{{  'dataSubs.status' | translate }}</th>
          </tr>
        </thead>
        <tbody class="text-white">
            <tr *ngFor="let table of tableData ; let i = index">
              <td style="text-align: center;">{{ 'monthmaps.' + table['month'] | translate }}</td>
              <td style="text-align: center">{{ 'listofdgc.' + table['status'] | translate }}</td>
            </tr>
        </tbody>
      </table>
    <!-- </cdk-virtual-scroll-viewport>  -->
    <div class="row" *ngIf = "tableData && tableData.length == 0">
      <div class="col-12 nodata">
        {{'infotab.nodata' | translate}}
      </div>
    </div>
  </div>
</div>
